import React from 'react';
import { useRouter } from 'next/router';
import PromoCarouselBlock from '../PromoCarouselBlock';
import { EPromoSlugs } from 'Types/globals';
import { useDispatch } from 'react-redux';
import { PATHS } from 'Libraries/routes.library';
import { openPromoModal } from 'Utils/modals';
import PromoPrimaryButton from '../PromoPrimaryButton/PromoPrimaryButton';
import PromoSecondaryButton from '../PromoSecondaryButton/PromoSecondaryButton';
import PromoBlock from '../PromoCarouselBlock/elements/PromoBlock/PromoBlock';
import PromoBlockButtons from '../PromoCarouselBlock/elements/PromoBlockButtons/PromoBlockButtons';
import PromoBlockContent from '../PromoCarouselBlock/elements/PromoBlockContent/PromoBlockContent';
import Content from './elements/Content';
import useShowAuthButtons from 'Hooks/useShowAuthButtons';

interface IWelcomeCarouselBlockProps {
  regtype?: any;
  free_spins_block: {
    id;
    title;
    description;
    countries_list: Array<string>;
    free_spins_item: Array<{ id; title; image; button_text; second_button_text }>;
  };
}

const WelcomeCarouselBlock = ({ free_spins_block, regtype }: IWelcomeCarouselBlockProps) => {
  const dispatch = useDispatch();
  const router = useRouter();

  const showRegisterButton = useShowAuthButtons();

  return (
    <PromoCarouselBlock withNavButtons={false}>
      <PromoBlock title={free_spins_block[0]?.title ?? ''} subtitle={free_spins_block[0]?.description ?? ''}>
        <PromoBlockButtons>
          {free_spins_block[0]?.button_text && showRegisterButton ? (
            <PromoPrimaryButton
              href={{
                pathname: PATHS.REGISTER,
                query: {
                  ...router.query,
                },
              }}
              dataQa="button-promo-block-register"
            >
              {free_spins_block[0]?.button_text}
            </PromoPrimaryButton>
          ) : null}

          {free_spins_block[0]?.second_button_text ? (
            <PromoSecondaryButton
              onClick={() => {
                openPromoModal(EPromoSlugs.WELCOME_PACK, dispatch);
              }}
            >
              {free_spins_block[0]?.second_button_text}
            </PromoSecondaryButton>
          ) : null}
        </PromoBlockButtons>
        <PromoBlockContent>
          <Content items={free_spins_block[0]?.free_spins_item} regtype={regtype} />
        </PromoBlockContent>
      </PromoBlock>
    </PromoCarouselBlock>
  );
};

export default WelcomeCarouselBlock;
